import { Flex, Space } from "antd"
import ExpandBtn from "../../../ui/ExpandBtn"
import NonManagedCampaign from "../../../components/NonManagedCampaign"
import CampaignActions from "./CampaignActions"
import CustomFilters from "./CustomFilter"
import { IPlacementDataForUpdate } from "../store/types/placements"

interface SettingsProps {
  isExpandedAll: boolean
  setIsExpandedAll: React.Dispatch<React.SetStateAction<boolean>>
  selectedCampaignIds: number[]
  setSelectedCampaignIds: React.Dispatch<React.SetStateAction<number[]>>
  setSelectCustomFilters: React.Dispatch<React.SetStateAction<string[]>>
  selectCustomFilters: string[]
  setPlacementsDataForUpdate: React.Dispatch<React.SetStateAction<IPlacementDataForUpdate[]>>
  placementDataForUpdate: IPlacementDataForUpdate[]
  minLimitedCPCByCampaignIdMap: Record<string, number>
}

const Settings: React.FC<SettingsProps> = ({
  isExpandedAll,
  setIsExpandedAll,
  selectedCampaignIds,
  setSelectedCampaignIds,
  setSelectCustomFilters,
  selectCustomFilters,
  setPlacementsDataForUpdate,
  placementDataForUpdate,
  minLimitedCPCByCampaignIdMap,
}) => {
  function handleExpand() {
    setIsExpandedAll((isExpanded) => !isExpanded)
  }

  return (
    <Flex justify="space-between" align="flex-start">
      <Space direction="vertical" size={8}>
        <Flex justify="flex-start">
          <ExpandBtn onClick={handleExpand} text={isExpandedAll ? "Close All" : "Expand All"} />
        </Flex>
        <NonManagedCampaign />
      </Space>
      <Flex vertical gap={8} align="flex-end">
        <CustomFilters
          setSelectCustomFilters={setSelectCustomFilters}
          setSelectedCampaignIds={setSelectedCampaignIds}
        />
        <CampaignActions
          selectedCampaignIds={selectedCampaignIds}
          selectCustomFilters={selectCustomFilters}
          setPlacementsDataForUpdate={setPlacementsDataForUpdate}
          placementDataForUpdate={placementDataForUpdate}
          minLimitedCPCByCampaignIdMap={minLimitedCPCByCampaignIdMap}
        />
      </Flex>
    </Flex>
  )
}

export default Settings
